import React from "react";
import { URLdecode, URLencode } from "../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";
import { pointsConfig } from "../../pointsConfig";

function MilesPointsTab() {
  const params = URLdecode();
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    {
      label: pointsConfig.tabs.points.label,
      code: pointsConfig.tabs.points.code,
      selected: !params?.tab,
    },
    {
      label: pointsConfig.tabs.leaderboard.label,
      code: pointsConfig.tabs.leaderboard.code,
    },
    {
      label: pointsConfig.tabs.rewards.label,
      code: pointsConfig.tabs.rewards.code,
    },
    {
      label: pointsConfig.tabs.badges.label,
      code: pointsConfig.tabs.badges.code,
    },
    {
      label: pointsConfig.tabs.referrals.label,
      code: pointsConfig.tabs.referrals.code,
    },
    {
      label: pointsConfig.tabs.log.label,
      code: pointsConfig.tabs.log.code,
    },
  ];

  return (
    <div className="w-full bg-[#F9F9F9] border border-[#E0E0E0] rounded-xl p-2 flex">
      {tabs.map((tab, tabIndex) => {
        const isSelected =
          (params?.tab && params?.tab === tab.code) || tab.selected;
        return (
          <button
            className={`flex flex-1 items-center justify-center h-12 rounded-xl text-sm font-bold ${
              isSelected
                ? "bg-primary1 text-white"
                : "text-[#6D7C94] bg-transparent"
            }`}
            onClick={() => {
              navigate(
                `${location.pathname}?${URLencode({
                  ...params,
                  tab: tab.code,
                })}`
              );
            }}
            key={tabIndex}
          >
            {tab?.label}
          </button>
        );
      })}
    </div>
  );
}

export default MilesPointsTab;
